module.exports = __webpack_public_path__ + "56fc132c08b498ac9a44f6cd153d7301.png";